module["exports"] = [
  "شمال",
  "شرق",
  "غرب",
  "جنوب",
  "جدید",
  "جزیره"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/fa/address/city_prefix.js
// module id = 2900
// module chunks = 1609